






import ViewModel from '@/layouts/Empty.ts';
export default ViewModel;
